import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { Locale } from '@synergy/models';

import { ProductListItem } from '../models/product-list-item';

export class ProductListApi {
    constructor(protected baseUrl: string) {}

    public getListItems(
        currency: string,
        locale: Locale,
        params?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<ProductListItem>>> {
        if (!params) {
            params = new URLSearchParams();
        }
        params.set('currency', currency);
        params.set('locale', locale);

        return safeRequest(
            () => request.get(`${this.baseUrl}/products`, { params }),
            response => response.data
        );
    }
}
